import { useEffect, useState } from "react";
import { Screen, Spinner, Text } from "@ferrivia/ui";
import { useTranslation } from "@ferrivia/i18n";
import s from "./GeneratingReportScreen.module.css";

const STEP_MS = 800;

/** Shown for the moment after a US client submits. Nothing is computed here:
    the report already exists once submit returns, and these lines only give
    the short wait a name. */
export function GeneratingReportScreen() {
  const { t } = useTranslation("client");
  const steps = [
    t("questionnaire.generating.steps.labs", "Kootaan laboratoriotuloksiasi"),
    t("questionnaire.generating.steps.answers", "Järjestetään vastauksiasi"),
    t("questionnaire.generating.steps.report", "Raporttia viimeistellään"),
  ];
  const [step, setStep] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setStep((current) => Math.min(current + 1, steps.length - 1)), STEP_MS);
    return () => clearInterval(id);
  }, [steps.length]);

  return (
    <Screen className={s.root}>
      <div className={s.centered} role="status" aria-live="polite">
        <Spinner />
        <Text as="h1" size="xl" weight="bold" className={s.title}>
          {t("questionnaire.generating.title", "Henkilökohtaista rautaraporttiasi luodaan…")}
        </Text>
        <Text as="p" size="md" className={s.step}>
          {steps[step]}
        </Text>
      </div>
    </Screen>
  );
}
